<template>
  <el-popover
    placement="bottom"
    v-model="showModal"
    :disabled="disabled"
    :trigger="trigger"
  >
    <div ref="search" class="tag-search-component" :class="{ product }">
      <div class="search-input">
        <div v-if="this.product" class="search-icon"></div>
        <input
          :placeholder="searchPlaceholder"
          v-model="searchText"
          @input="search"
        />
        <div
          v-if="this.people"
          @click="searchClick"
          :class="{ disabled: !this.searchText }"
          class="search-icon-container"
        ></div>
      </div>
      <div class="search-result-container" ref="scrollView" v-if="this.product">
        <div class="loading" v-show="loading">
          <i class="el-icon-loading"></i>
          <div class="search-for">{{ searchingText }}</div>
        </div>
        <div
          v-show="
            !loading && list.length === 0 && searchText && userTags.length === 0
          "
          class="no-account"
        >
          No account found
        </div>
        <!-- <template v-if="people">
          <div class="search-item" :key="item.user_id" v-for="item in list"
               @click="itemClick(item)">
            <div class="person-image" v-lazy:background-image="item.image" :key="item.image"></div>
            <div class="person-main-container">
              <div class="person-main-container">
                <div class="username-container">
                  <div class="username">{{item.username}}</div>
                  <div class="approve-icon" v-show="item.isVerified"></div>
                </div>
                <div class="des">{{item.full_name}}</div>
              </div>
            </div>
          </div>
        </template> -->
        <template v-if="product">
          <div
            class="search-product-item"
            v-for="item in list"
            :key="item.id"
            @click="itemClick(item)"
          >
            <div
              class="product-image"
              v-lazy:background-image="item.image_url"
              :key="item.image_url"
            ></div>
            <div class="product-info">
              <div class="product-name">{{ item.name }}</div>
              <div class="product-price">{{ item.current_price }}</div>
            </div>
          </div>
        </template>
        <div class="loading load-more" v-show="showLoadMore">
          <i class="el-icon-loading"></i>
        </div>
        <div class="loading load-more" v-show="showEnd">end</div>
      </div>
    </div>
    <slot slot="reference">
      <div
        style="width: 1px; height: 1px"
        slot="reference"
        @click="showModal = true"
      ></div>
    </slot>
  </el-popover>
</template>

<style lang="less" scoped>
@import "../../../assets/style/theme.less";

.tag-search-component {
  width: 224px;
  min-height: 55px;
  max-height: 350px;
  background-color: #ffffff;
  border-radius: 4px;
  padding: 10px 0 0 0;
  display: flex;
  flex-direction: column;
  &.product {
    width: 345px;
    min-height: 400px;
    max-height: 500px;
  }
  .search-input {
    border: 1px solid @border-color;
    border-radius: 4px;
    height: 36px;
    display: flex;
    align-items: center;
    padding: 0 5px;
    margin: 0 10px;

    .search-icon {
      width: 22px;
      height: 22px;
      background-size: contain;
      background-image: url("../../../../public/images/schedule_posts/tag_people/tagpeople_search@3x.png");
    }

    input {
      font-size: 12px;
      border: 0;
      width: 100%;
    }
    .search-icon-container {
      height: 24px;
      width: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      &.disabled {
        opacity: 0.8;
        cursor: not-allowed;
      }
      &:hover,
      &:active {
        opacity: 0.8;
      }
      background-image: url("../../../../public/images/schedule_posts/tag_@3x.png");
    }
  }

  .search-result-container {
    overflow: auto;
    flex: 1;
    height: 200px;
    max-height: 200px;
    .loading {
      padding: 5px 15px;
      color: @font-color-gray;

      &.load-more {
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      i {
        font-size: 20px;
      }

      height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .search-for {
        font-size: 14px;
        flex: 1;
        text-align: left;
        margin-left: 10px;
      }
    }

    .no-account {
      padding: 0 15px;
      color: @font-color-gray;
      font-size: 14px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .search-product-item {
      display: flex;
      align-items: center;
      padding: 0 15px;
      cursor: pointer;
      height: 53px;

      &:hover {
        background-color: rgba(230, 43, 85, 0.1);
      }

      .product-image {
        height: 32px;
        width: 32px;
        background-size: contain;
      }

      .product-info {
        flex: 1;
        margin-left: 10px;
        height: 54px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .product-name {
          font-size: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 260px;
          text-align: left;
          color: black;
        }

        .product-price {
          font-size: 12px;
          color: #5a5a5a;
        }
      }
    }

    .search-item {
      display: flex;
      align-items: center;
      padding: 8px 15px;
      cursor: pointer;

      &:hover {
        background-color: rgba(230, 43, 85, 0.1);
      }

      .person-image {
        height: 32px;
        width: 32px;
        border-radius: 50%;
        background-size: contain;
      }

      .person-main-container {
        margin-left: 5px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        overflow: hidden;

        .username-container {
          display: flex;
          align-items: center;

          .username {
            font-size: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .approve-icon {
            background-image: url("../../../../public/images/schedule_posts/tag_people/approve@3x.png");
            width: 12px;
            height: 12px;
            background-size: contain;
            margin-left: 4px;
            position: relative;
          }
        }

        .des {
          font-size: 12px;
          color: @font-color-gray;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>

<script>
import { searchInsUsers, searchProduct } from "../../../service/instagram";
import _ from "lodash";
import { showErrorMsg } from "../../../utils/errors";
import { sleep } from "../../../utils";

export default {
  name: "TagSearchComponent",
  model: {
    // 实现v-model
    prop: "val",
    event: "updateVal",
  },
  props: {
    tags: {
      // user tag
      type: Array,
      default: () => [],
    },
    max: {
      type: Number,
      default: 0,
    },
    current: {
      require: true,
    },
    type: {
      type: String,
      default: "people",
    },
    val: {
      type: Boolean, // 是否显示窗口
      default: false,
    },
    trigger: {
      // 弹窗显示形式
      type: String,
      default: "manual",
    },
    disabled: {
      // 是否禁止点击
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: this.val, // 展示信息
      searchList: [], // 查询结果
      searchText: "", // 输入的查询伟岸
      loadMore: false, // 是否显示加载更多
      loading: false, // 展示loading
    };
  },
  computed: {
    /**
     * 是否拥有tag权限
     * @returns {*}
     */
    tagPermission() {
      return this.publisher.permissions.timeline_video_usertags;
    },
    product() {
      return this.type === "product";
    },
    people() {
      return this.type === "people";
    },
    /**
     * 列表显示数据
     */
    list() {
      if (this.product) {
        return this.searchList;
      }
      if (this.people) {
        if (this.searchText) {
          return this.searchList;
        } else {
          // 如果不存在查询条件则显示现在选中项
          return this.tags.filter((u) => u.image);
        }
      }
    },
    searchingText() {
      if (this.product && this.searchText === "") {
        return "Loading";
      }
      return `Searching for "${this.searchText}"`;
    },
    /**
     * 搜索框文案
     */
    searchPlaceholder() {
      if (this.product) {
        return "Search for a product";
      }
      if (this.people) {
        return "Username";
      }
    },
    /**
     * 是否显示end
     */
    showEnd() {
      if (this.product) {
        return this.loadingSuccess && !this.nextId && this.list.length > 0;
      }
      if (this.people) {
        return false;
      }
    },
    /**
     * 是否数据已经加载完成
     */
    loadingSuccess() {
      return !this.loading && !this.loadMore;
    },
    /**
     * 是否显示加载更多
     */
    showLoadMore() {
      if (this.product) {
        return this.loadMore;
      }
      if (this.people) {
        return false;
      }
    },
  },
  watch: {
    searchText(val, old) {
      if (val) {
        this.loading = true;
        this.searchList = [];
      } else {
        this.loading = false;
      }
    },
    /**
     * 监听文本值变化，变化时触发updateVal事件，实现双向绑定
     */
    showModal(val) {
      // 如果关闭则清空各种状态
      if (!val) {
        this.close();
      }
      this.$emit("updateVal", val);
    },
    /**
     * 当props val变化时改变data中value值，从而实现双向绑定
     */
    val(val) {
      this.value = val;
    },
  },
  methods: {
    search: _.debounce(async function (e) {
      if (this.people) {
        return;
      }
      const q = e.target.value;
      if (q) {
        await this.loadData({ reload: true, q });
      } else {
        // 如果未输入则清空数据数据(只有tag people)
        if (this.people) {
          this.searchList = [];
          this.loading = false;
        }
      }
    }, 500),
    async loadData({ reload = true, q = "" }) {
      try {
        if (reload) {
          this.loading = true;
        } else {
          this.loadMore = true;
        }
        let result = {};
        if (this.people) {
          // 开始查询
          result = await searchInsUsers({ q });
        } else if (this.product) {
          let nextId = this.nextId;
          if (reload) nextId = "";
          // 开始查询
          result = await searchProduct({ q, nextId });
        }
        if (reload) {
          this.searchList = result.list; // 查询所得数据
        } else {
          this.searchList.push(...result.list);
        }
        // reload 则清空 下一页参数 （nextid）
        this.nextId = result.nextId;
      } catch (e) {
        showErrorMsg(e);
      } finally {
        await sleep({ time: 100 });
        this.loading = false;
        this.loadMore = false;
      }
    },
    /**
     * 弹出搜索单条点击事件
     * @param item 单条点击事件
     */
    itemClick(item) {
      this.$emit("itemClick", item);
    },
    searchClick() {
      if (this.searchText) {
        this.$emit("itemClick", {
          user_id: this.searchText,
          username: this.searchText,
        });
      }
    },
    /**
     * 打开弹出
     */
    async open() {
      this.showModal = false;
      await sleep({ time: 50 });
      this.showModal = true;
      // 如果是tag product则开始就加载数据
      if (this.product) {
        await this.loadData({});
      }
    },
    close() {
      this.showModal = this.loading = this.loadMore = false;
      this.searchText = "";
      this.searchList = [];
    },
  },
  mounted() {
    if (this.trigger === "manual") {
      // 点击其他区域消失
      window.document.addEventListener("click", (e) => {
        if (this.$refs.search && !this.$refs.search.contains(e.target)) {
          this.showModal = false;
        }
      });
      // window.document.addEventListener('input', e => {
      //   if (this.$refs.search && !this.$refs.search(e.target)) {
      //     this.showModal = false
      //   }
      // })
    }
    const scrollerView = this.$refs.scrollView;
    scrollerView.addEventListener("scroll", async () => {
      const h = scrollerView.clientHeight; // div可视区域的高度
      const sh = scrollerView.scrollHeight; // 滚动的高度，$(this)指代jQuery对象，而$(this)[0]指代的是dom节点
      const st = scrollerView.scrollTop; // 滚动条的高度，即滚动条的当前位置到div顶部的距离
      if (h + st >= sh) {
        if (this.loadingSuccess) {
          // 上面的代码是判断滚动条滑到底部的代码
          await this.loadData({ reload: false });
        }
      }
    });
  },
};
</script>
